import { View } from "dripsy";
import React, { useEffect, useState } from "react";
import {
  UniRadioButton,
  UniRadioButtonGroupOnValueChangeProps,
} from "./uniRadioButton";

export interface UniRadioGroupItemOption<T> {
  value: T;
  label: string;
}

export interface UniRadioButtonGroupProps<T> {
  name: string;
  options: Array<UniRadioGroupItemOption<T>>;
  defaultValue?: T;
  onValueChange: (changed: UniRadioButtonGroupOnValueChangeProps) => void;
}

export const UniRadioButtonGroup = <T,>(props: UniRadioButtonGroupProps<T>) => {
  const { name, options, onValueChange } = props;
  const [value, setValue] = useState<T | undefined>(undefined);

  useEffect(() => {
    onValueChange({
      name,
      value,
    });
  }, [value]);

  return (
    <View>
      {options.map((item, index) => (
        <UniRadioButton<T>
          key={`radio-group-${name}-${index}`}
          name={name}
          value={value}
          label={item.label}
          buttonValue={item.value}
          onValueChange={setValue}
        />
      ))}
    </View>
  );
};
